import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux'
import store from './store/index'
import { RouterProvider } from 'react-router-dom'
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import router from './router/router';

// Perfect Scrollbar
import 'react-perfect-scrollbar/dist/css/styles.css';

// Tailwind css
import './tailwind.css'
import './custom.css'

// i18n (needs to be bundled)
import './i18n'
import PersistProvider from './redux/persist-provider';
import { setAxiosClientInterceptor } from './helpers/apiClient';

setAxiosClientInterceptor();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
    <>
    <Suspense>
        <Provider store={store}>
            <PersistProvider>
                <RouterProvider router={router} />
            </PersistProvider>
        </Provider>
    </Suspense>
    <ToastContainer />
    </>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
